import {
  SET_LOADER_START,
  SET_LOADER_COMPLETE
} from '../../constants';

export const setLoaderStart = (name) => {
  return {
    type: SET_LOADER_START,
    payload: {
      name,
      status: true
    }
  };
}

export const setLoaderComplete = (name) => {
  return {
    type: SET_LOADER_COMPLETE,
    payload: {
      name,
      status: false
    }
  };
}